
import Opportunity from '@/models/Opportunity'
import ViewModel from '@/models/ViewModel'
import {
  Component, Prop, Ref, Vue, Watch,
} from 'vue-property-decorator'
import DatePicker from '@/components/DatePicker/DatePicker.vue'
import FormInput from '@/components/FormInput/FormInput.vue'
import { currencyMask } from '@/models/interface/Masks'
import WebMessage from '@/models/WebMessage'
import MediaPlan from '@/models/MediaPlan'
import SelectPicker from '@/components/SelectPicker/SelectPicker.vue'

@Component({
  components: {
    DatePicker,
    FormInput,
    SelectPicker,
  },
})
export default class statusChange extends ViewModel {
  @Ref()
  public lost_validator!: any

  @Ref()
  public readonly stageChanger!: any

  @Prop({ required: true })
  public item!: any

  @Prop({ required: false })
  public disabled!: boolean

  @Prop({ required: true })
  public onlyEdit!: Array<any>

  @Prop({ required: true })
  public refreshAll!: boolean

  // Keep the working copy in sync with the row's item. The DataTable's b-table
  // has no primary-key, so on pagination/filter changes Vue reuses these row
  // component instances and only swaps the `item` prop — without this watcher
  // temp_opportunity (and the id sent to the API) would keep the previous row's
  // values and the stage change would hit the wrong opportunity.
  @Watch('item', { immediate: true })
  public onItemChange() {
    this.temp_opportunity = Opportunity.toObject(this.item)
  }

  @Watch('refreshAll')
  public onRefreshAll(val: boolean) {
    if (val) {
      this.temp_opportunity = Opportunity.toObject(this.item)
    }
  }

  public lost_categories: any = Opportunity.option_list.lost_categories

  public openPopOver: boolean = false

  public loading: boolean = false

  public id: any = this.randomUUID()

  public temp_opportunity: Opportunity = new Opportunity()

  public get stauts_list() {
    let source = [
      'prospecting',
      'discovery',
      'presenting',
      'proposing',
      'negotiating',
      'expected',
      'processing',
    ]

    if (this.onlyEdit && this.onlyEdit.length) {
      source = this.onlyEdit
    }

    const status = Opportunity.opportunity_status.filter((o: any) => source.includes(o.code))

    return status
  }

  public get interactable() {
    return !['lost', 'won'].includes(this.item.status)
  }

  public selected_targeting: boolean = false

  public check_media_plan: boolean = false

  public checking_media_plan: boolean = false

  public cant_be_saved: boolean = false

  public media_plan!: MediaPlan

  public get opportunity_cant_be_saved() {
    return this.temp_opportunity.cant_be_saved
  }

  public get opportunityMediaPlanCheck() {
    return this.temp_opportunity.media_plan
  }

  @Watch('opportunityMediaPlanCheck')
  public onOppMPChange(value: any) {
    if (value) this.media_plan = value
  }

  @Watch('opportunity_cant_be_saved')
  public onOppCantBeSavedChange(value: any) {
    this.cant_be_saved = value
  }

  public async updateStatus(status: any) {
    this.$root.$emit('bv::hide::popover', `status-popover-${this.item.id}`)
    this.loading = true
    let canSaveNow = null
    if (status.code === 'lost') {
      canSaveNow = await this.checkMediaPlanOnLost(status)
      if (!canSaveNow) {
        return
      }
    }

    this.temp_opportunity.status = status.code
    this.temp_opportunity.percentage = status.value

    if (status.code === 'lost') {
      return
    }
    Opportunity.forceStatusUpdate(this.temp_opportunity, 'status').then(res => {
      this.loading = false
      this.openPopOver = false
      this.selected_targeting = false
      this.$emit('saved')
    })
  }

  public get masks() {
    return {
      currency: currencyMask,
    }
  }

  public onPopoverShow(bvEventObj: any) {
    if (bvEventObj.componentId !== `status-popover-${this.item.id}`) {
      this.openPopOver = false
    }
  }

  public mounted() {
    // temp_opportunity is initialized by the immediate `item` watcher above.
    this.$root.$on('bv::popover::show', this.onPopoverShow)
  }

  public beforeDestroy() {
    // Remove the global listener and tear down any open popover so BootstrapVue
    // doesn't try to resolve this row's (now-detached) target after the row is
    // removed on a filter/pagination change.
    this.$root.$off('bv::popover::show', this.onPopoverShow)
    this.openPopOver = false
    this.$root.$emit('bv::hide::popover', `status-popover-${this.item.id}`)
  }

  /**
   * @deprecated
   * this is for ref only, delete later
   */
  // public showWarning() {
  //   if (this.onlyEdit.includes(this.item.status)) {
  //     return
  //   }

  //   if (this.item.status === 'targeting') {
  //     WebMessage.warning('To move the status above targeting, please request a media plan.')
  //   } else {
  //     WebMessage.warning(
  //       'The status can not be updated, it will be automatically updated with the media plan.',
  //     )
  //   }
  // }

  public updateToLost() {
    this.loading = true
    this.temp_opportunity.status = 'lost'
    this.temp_opportunity.percentage = 0

    Opportunity.forceStatusUpdate(this.temp_opportunity, ['status', 'close_reason']).then(res => {
      this.$emit('saved')
      this.resetOppMPSearch()
    })
  }

  public resetOppMPSearch() {
    this.check_media_plan = false
    this.loading = false
    this.cant_be_saved = false
    this.selected_targeting = false
    this.openPopOver = false
    this.temp_opportunity.resetStatusCheck()
  }

  /**
   * @deprecated
   * for reference only, delete after review
   */
  public old_checkMediaPlanOnLost() {
    if (this.item.main_media_plan_id) {
      this.check_media_plan = true
      this.checking_media_plan = true

      MediaPlan.find(this.item.main_media_plan_id).then((response: MediaPlan) => {
        this.media_plan = response
        if (
          response.metrics
          && response.metrics.hasOwnProperty('impressions')
          && response.metrics.impressions > 0
        ) {
          this.cant_be_saved = true
          this.checking_media_plan = false
        } else {
          this.cant_be_saved = false
          this.checking_media_plan = false
        }
      })

      return false
    }

    return true
  }

  public async checkMediaPlanOnLost({ code, value }: { code: string; value: number }) {
    try {
      let can_change = await this.temp_opportunity.changeStage({ code, value, reason: true })
      return can_change
    } catch (error) {
      return false
    } finally {
      this.loading = false
    }
  }
}
